import { ifProp } from 'mol-ui';
import styled from 'styled-components';

export const Container = styled.div`
    align-items: center;
    display: flex;
    justify-content:  flex-start;
    margin: ${ ifProp('disabled', '10px 0px 20px 0px', '0px') };
    padding: ${ ifProp('disabled', '0px 0px 20px 0px', '') };
`;
